import * as React from 'react';
import './HeaderMenuItemSeparator.css';
export const HeaderMenuItemSeparator = () => React.createElement("div", { className: "vai-header-menu-item-separator" });
//# sourceMappingURL=HeaderMenuItemSeparator.js.map